import {
    ListItemButton, Icon,
    ListItemIcon, ListItemText
} from '@mui/material'

import { useEffect, useRef, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { DISABLED, SELECTED, DEFAULT } from '../../../../services/theme'

import Config from '../../../../features/config.json'

import Styles from './style'

export const Link = (props) => {
    const url = useLocation()
    const pathname = url.pathname
    const navigate = useNavigate()
    const asPortal = useRef(Config.interface?.navigation?.asPortal ?? false)

    const [mode, setMode] = useState(DEFAULT)

    useEffect(() => {
        if (props.disabled) setMode(DISABLED)
    }, [])

    useEffect(() => {
        if (props.disabled) return
        setMode((pathname.includes(`${props.path}`)) ? SELECTED : DEFAULT)
    }, [pathname])

    const handleNavigate = () => {
        if (props.disabled || props.target) return
        navigate(props.path)
    }

    return (
        <ListItemButton
            onClick={handleNavigate}
            className={mode}
            disabled={props.disabled}
            sx={(asPortal.current) ? Styles.rootPortal : Styles.root}
        >
            <ListItemIcon>
                {props.icon && (<Icon>{props.icon}</Icon>)}
            </ListItemIcon>
            {(props.target)
                ? (<a href={props.path} target={props.target} style={Styles.link}><ListItemText primary={props.label} /></a>)
                : (<ListItemText primary={props.label} />)
            }
        </ListItemButton>
    )
}

export default Link